import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3144, { U3144ROLES } from "./U3144";
import U3144LotDetailOperationTypeList from "./components/U3144LotDetailOperationTypeList";
import U3144LotDetailOperationTypeForm from "./components/U3144LotDetailOperationTypeForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3144Routes: RouteObject[] = [
  {
    path: "U3144",
    element: <U2000RequireRole allowedRoles={[U3144ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3144 />,
        children: [
          { index: true, element: <U3144LotDetailOperationTypeList /> },
          { path: ":id", element: <U3144LotDetailOperationTypeForm /> },
        ],
      },
    ],
  },
];

export default U3144Routes;
